import { Fragment } from "react";
import StaedteError from "./Error";

export default function CityDetails(params) {
	
	const cityDetails = params.data;

    return <Fragment>
        {
            !cityDetails.errors ? 
            <div className='mt-3'>
                <div className='av-special-heading av-special-heading-h1 avia-builder-el-1 el_after_av_image el_before_av_one_half border-dark'>
                    <h1 className='av-special-heading-tag' itemProp='headline'>
                        {cityDetails.city_name}
                    </h1>
                    <div className='special-heading-border'>
                        <div className='special-heading-inner-border fat-after-heading'></div>
                    </div>
                </div>
            </div> :
            <StaedteError />
        }
    </Fragment>

}
